module.exports = __webpack_public_path__ + "img/icon.3b6726db.png";